import { type FC, useCallback } from "react";
import { ButtonKind, ButtonSize, ButtonVariant } from "@viagogo/core/ui";
import { useContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { DownArrowIcon } from "./DownArrowIcon";
import { StyledButton, StyledIconWrapper } from "./styled-components";

interface Props {
  onClick: () => void;
}

/**
 * Button to Anchor to TeamsSection
 * @see https://www.figma.com/file/Y9JIAqbF7ljecUFj4yAypS/General-Innovation-XPs---Master?node-id=308-3899&t=XoBKXQnmp7tJ91hz-4
 */
export const ViewAllTeamsButton: FC<Props> = ({ onClick }) => {
  const storePageEvent = useStorePageEvent();
  const content = useContent("cid$#3094910#");
  const handleClick = useCallback(() => {
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.CATEGORY_GROUPING_ALL_TEAMS_CLICK, "");
    onClick();
  }, [onClick, storePageEvent]);

  return (
    <StyledButton
      kind={ButtonKind.primary}
      onClick={handleClick}
      size={ButtonSize.default}
      variant={ButtonVariant.regular}
    >
      {content}
      <StyledIconWrapper>
        <DownArrowIcon />
      </StyledIconWrapper>
    </StyledButton>
  );
};
